import React from 'react';

const Core = (props) => {
  return (
    <div className="centerPanel">
      <div className="centerPanelItem">
        <label htmlFor="initialInvestment">Initial Investment ($)</label>
        <br />
        <input
          type="number"
          name="initialInvestment"
          placeholder="Enter initial investment..."
          onChange={props.updateInputs}
        ></input>
      </div>
      <div className="centerPanelItem">
        <label htmlFor="annualAddition">Annual Addition ($)</label>
        <br />
        <input
          type="number"
          name="annualAddition"
          placeholder="Enter annual addition..."
          onChange={props.updateInputs}
        ></input>
      </div>
      <div className="centerPanelItem">
        <label htmlFor="investmentReturn">Investment Return (%)</label>
        <br />
        <input
          type="number"
          name="investmentReturn"
          placeholder="Enter investment return..."
          onChange={props.updateInputs}
        ></input>
      </div>
      <div className="centerPanelItem">
        <label htmlFor="duration">Duration (in years)</label>
        <br />
        <input
          type="number"
          name="duration"
          placeholder="Enter duration..."
          onChange={props.updateInputs}
        ></input>
      </div>
    </div>
  );
};

export default Core;
